import { defineStore } from 'pinia'

export const useWadLoadingStore = defineStore('wadLoading', () => {
  const loading = ref(false)

  function start() {
    loading.value = true
  }

  function stop() {
    loading.value = false
  }

  return {
    loading,
    start,
    stop,
  }
})
